import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { VehicleEyeStateService } from '../../service/vehicle-eye-state.service';
import { StateVehicleService } from '../../service/state-vehicle.service';
import { UnitCollectionService } from '../../service/unit-collection.service';
import { VehicleConfig, VehicleDisplay } from 'src/app/shared/models/configuration';
import { VehicleConfigService } from 'src/app/vehicles/services/vehicle-config.service';
@Component({
  selector: 'app-checkbox-container-vehicle',
  templateUrl: './checkbox-container-vehicle.component.html',
  styleUrls: ['./checkbox-container-vehicle.component.scss'],
})
export class CheckboxContainerVehicleComponent implements OnInit {
  @Output() disabledFollow = new EventEmitter<void>();
  @Output() disabledFormatedOperation = new EventEmitter<boolean>();
  @Output() disabledFilterEye = new EventEmitter<boolean>();
  public isCheckedFollowVehicles = true;
  public isCheckedFormatedOperation = false;
  public isCheckedFilterEye = false;

  public valueOldService: any;
  constructor(
    public vehicleConfigService: VehicleConfigService,
    private vehicleService: VehicleService,
    private vehicleEyeStateService: VehicleEyeStateService,
    private stateVehicleService: StateVehicleService,
    private unitCollectionService: UnitCollectionService,
    private cdr: ChangeDetectorRef
  ) {
    this.valueOldService = vehicleService.allEyes;
    this.isCheckedFollowVehicles =
      this.vehicleEyeStateService.getGlobalEyeState();
    this.isCheckedFilterEye = unitCollectionService.getStateFilterEye();
  }

  ngOnInit(): void {
    let view = this.vehicleConfigService.configuration.view;
    this.updateToggleChecks(view)
  }

  updateToggleChecks(display : any){
    if(!this.vehicleConfigService.applyViewConfig){
      this.toggleCheckFilterEye(display.showOnlyVisible.enabled)
      this.toggleCheckFormatedOperation(display.showByOperation.enabled)
      this.toggleCheckFollowVehicles(display.showOnMap.enabled)
      this.vehicleConfigService.applyViewConfig = true;
    }
  }

  toggleCheckFollowVehicles(isChecked: boolean): void {
    this.isCheckedFollowVehicles = isChecked;
    this.vehicleEyeStateService.updateGlobalEyeState(isChecked);
    this.stateVehicleService.setVisibleGlobal(isChecked);

    this.cdr.markForCheck();

    // OLD SERVICE
    const vehicles = this.vehicleService.vehicles;
    if (!this.isCheckedFollowVehicles && vehicles.length > 0) {
      this.disabledFollow.emit();
    }
    for (let vh of vehicles) {
      vh.eye = this.isCheckedFollowVehicles;
    }
    this.vehicleService.countOpenEyes = this.isCheckedFollowVehicles
      ? this.vehicleService.vehicles.length
      : 0;

    if (this.isCheckedFilterEye)
      this.unitCollectionService.applyFilterForEyePublic(true);

    this.vehicleService.drawIconMap.emit();
    this.vehicleConfigService.configuration.view.showOnMap.enabled = isChecked;
    /* this.vehicleService.updateShowTableTree.emit(this.isCheckedFollowVehicles); */
  }

  toggleCheckFormatedOperation(isChecked: boolean): void {
    this.isCheckedFormatedOperation = isChecked;
    this.disabledFormatedOperation.emit(isChecked);
    this.vehicleConfigService.configuration.view.showByOperation.enabled = isChecked;
  }

  toggleCheckFilterEye(isChecked: boolean): void {
    this.isCheckedFilterEye = isChecked;
    this.disabledFilterEye.emit(isChecked);
    this.vehicleConfigService.configuration.view.showOnlyVisible.enabled = isChecked;
  }
}
